export default __webpack_public_path__ + "a40218c19d5c7f7b482f8e596a8c0a74.png";